import { __decorate, __extends } from "tslib";
import { _GraphQueryableInstance, _GraphQueryableCollection, graphInvokableFactory, } from "../graphqueryable.js";
import { defaultPath, getById } from "../decorators.js";
/**
 * Represents a insights entity
 */
var _Insights = /** @class */ (function (_super) {
    __extends(_Insights, _super);
    function _Insights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_Insights.prototype, "trending", {
        get: function () {
            return TrendingInsights(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_Insights.prototype, "used", {
        get: function () {
            return UsedInsights(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(_Insights.prototype, "shared", {
        get: function () {
            return SharedInsights(this);
        },
        enumerable: false,
        configurable: true
    });
    _Insights = __decorate([
        defaultPath("insights")
    ], _Insights);
    return _Insights;
}(_GraphQueryableInstance));
export { _Insights };
export var Insights = graphInvokableFactory(_Insights);
/**
 * Describes a Trending Insight instance
 */
var _TrendingInsight = /** @class */ (function (_super) {
    __extends(_TrendingInsight, _super);
    function _TrendingInsight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_TrendingInsight.prototype, "resource", {
        get: function () {
            return Resource(this);
        },
        enumerable: false,
        configurable: true
    });
    return _TrendingInsight;
}(_GraphQueryableInstance));
export { _TrendingInsight };
export var TrendingInsight = graphInvokableFactory(_TrendingInsight);
/**
 * Describes a collection of Trending Insight objects
 *
 */
var _TrendingInsights = /** @class */ (function (_super) {
    __extends(_TrendingInsights, _super);
    function _TrendingInsights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _TrendingInsights = __decorate([
        defaultPath("trending"),
        getById(TrendingInsight)
    ], _TrendingInsights);
    return _TrendingInsights;
}(_GraphQueryableCollection));
export { _TrendingInsights };
export var TrendingInsights = graphInvokableFactory(_TrendingInsights);
/**
 * Describes a Used Insight instance
 */
var _UsedInsight = /** @class */ (function (_super) {
    __extends(_UsedInsight, _super);
    function _UsedInsight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_UsedInsight.prototype, "resource", {
        get: function () {
            return Resource(this);
        },
        enumerable: false,
        configurable: true
    });
    return _UsedInsight;
}(_GraphQueryableInstance));
export { _UsedInsight };
export var UsedInsight = graphInvokableFactory(_UsedInsight);
/**
 * Describes a collection of Used Insight objects
 *
 */
var _UsedInsights = /** @class */ (function (_super) {
    __extends(_UsedInsights, _super);
    function _UsedInsights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _UsedInsights = __decorate([
        defaultPath("used"),
        getById(UsedInsight)
    ], _UsedInsights);
    return _UsedInsights;
}(_GraphQueryableCollection));
export { _UsedInsights };
export var UsedInsights = graphInvokableFactory(_UsedInsights);
/**
 * Describes a Shared Insight instance
 */
var _SharedInsight = /** @class */ (function (_super) {
    __extends(_SharedInsight, _super);
    function _SharedInsight() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_SharedInsight.prototype, "resource", {
        get: function () {
            return Resource(this);
        },
        enumerable: false,
        configurable: true
    });
    return _SharedInsight;
}(_GraphQueryableInstance));
export { _SharedInsight };
export var SharedInsight = graphInvokableFactory(_SharedInsight);
/**
 * Describes a collection of Shared Insight objects
 *
 */
var _SharedInsights = /** @class */ (function (_super) {
    __extends(_SharedInsights, _super);
    function _SharedInsights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _SharedInsights = __decorate([
        defaultPath("shared"),
        getById(SharedInsight)
    ], _SharedInsights);
    return _SharedInsights;
}(_GraphQueryableCollection));
export { _SharedInsights };
export var SharedInsights = graphInvokableFactory(_SharedInsights);
/**
 * Describes a Resource Entity instance
 */
var _Resource = /** @class */ (function (_super) {
    __extends(_Resource, _super);
    function _Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Resource = __decorate([
        defaultPath("resource")
    ], _Resource);
    return _Resource;
}(_GraphQueryableInstance));
export { _Resource };
export var Resource = graphInvokableFactory(_Resource);
//# sourceMappingURL=types.js.map